import { userInfoStore } from '../../../store/userInfoStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { plinkoBetsStore } from '../plinkoStore/gameStore';
import { plinkoGameConnection } from '../plinkoConnection';
import { autoBetStore } from '../../../store/autoBetStore';
import { DEFAULT_AUTO_BET_COUNT } from '../../../core/constants/autoBetContants';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { PlinkoSoundNames } from '../plinkoCore/constants/sounds';
import { gameDrawer } from '../plinkoGameDrawer/GameDrawer';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { popupStore } from '../../../store/popupStore';
import { PopupTypes } from '../../../core/constants/popupTypes';
import { BALL_COUNT, linesCountByRowType, plinkoRowType, RiskType } from '../plinkoCore/enums';
import { freeBetStore } from '../../../store/freeBetStore';

let autoBetTimeOutId;

class PlinkoGameService {
  onGetInitialStateResult({ lastSpinInfo, additionalInfo }) {
    this.resetInitial();
    // if (!gameDrawer.mainBalls.length) {
    plinkoBetsStore.rowType = plinkoRowType._10;
    plinkoBetsStore.linesCount = linesCountByRowType[plinkoBetsStore.rowType];
    plinkoBetsStore.riskType = RiskType.medium;
    plinkoBetsStore.ballCount = BALL_COUNT._1;
    // }
    gameDrawer.handleRemoveBalls();
    plinkoBetsStore.setOddsAndIndexes(additionalInfo.oddsAndIndexs);
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        balls: lastSpinInfo.balls,
        id: lastSpinInfo.id,
      });
    }
  }

  doSpin() {
    if (
      !(
        popupStore.popupName === PopupTypes.Deposit ||
        plinkoBetsStore.isBetsClosed ||
        (!autoBetStore.isAutoBetStart && !plinkoBetsStore.isAllowedNextBet)
      ) &&
      document.visibilityState === 'visible'
    ) {
      soundService.play(PlinkoSoundNames.bet);
      const { riskType, rowType, ballCount } = plinkoBetsStore;
      plinkoBetsStore.setIsBetsClosed(true);
      !plinkoBetsStore.isHaveCirclesInPlinko && plinkoBetsStore.setIsHaveCirclesInPlinko(true);
      if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
        autoBetStore.setIsAutoBetStart(true);
      }
      mainGameConnection.doSpin({
        isAutoplay: autoBetStore.isAutoBetOn,
        isTurbo: userSettingsStore.isTurboOn,
        spinData: {
          plinkoRowType: rowType,
          ballCount,
          riskType,
        },
      });
    }
  }

  handleDoSpinResult({ result, responseCode, id, balance, ...all }) {
    plinkoBetsStore.setIsBetsClosed(false);
    if (responseCode === ValidationType.Success) {
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      const { balls, paths, row, risk } = result;
      checkHashStore.setLastRoundResult({
        row,
        risk,
        id: id,
      });
      const { setAutoBetCount, setIsAutoBetStart, autoBetCount, isAutoBetStart, setIsAutoBetOn } =
        autoBetStore;
      for (let index = 0; index < paths.length; index += 1) {
        const path = paths[index];
        gameDrawer.setMainBall(path, {
          ...{ responseCode, balance, id, ...all, ...result },
          isAllowedBalanceUpdate: index === paths.length - 1,
          result: balls[index],
        });
      }
      // if (document.visibilityState === 'visible') {
      //   for (let index = 0; index < res.paths.length; index += 1) {
      //     const path = res.paths[index];
      //     gameDrawer.setMainBall(path, {
      //       ...res,
      //       isAllowedBalanceUpdate: index === res.paths.length - 1,
      //       result: res.balls[index],
      //     });
      //   }
      // } else {
      //   setTimeout(() => {
      //     userInfoStore.getBalance();
      //     betHistoryStore.getLastBet();
      //     checkHashStore.setLastRoundInfo(res);
      //     checkHashStore.setNextRoundHash(res.newHash);
      //   }, 1000);
      //   res.balls.forEach((item) => plinkoBetsStore.updateLastResults(item));
      // }
      // userInfoStore.setUserBalance(balance);
      notificationStore.setNotification(responseCode);
      setTimeout(() => {
        if (isAutoBetStart) {
          const newAutoBetCount = autoBetCount - 1;
          setAutoBetCount(newAutoBetCount);
          if (newAutoBetCount > 0) {
            autoBetTimeOutId = setTimeout(
              this.doSpin,
              plinkoBetsStore.isAllowedNextBet ? 2000 : 6000
            );
          } else {
            setIsAutoBetStart(false);
            setIsAutoBetOn(false);
            setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
          }
        }
      }, 100);
    } else {
      if (!gameDrawer.mainBalls.length) {
        plinkoBetsStore.setIsHaveCirclesInPlinko(false);
      }
      const { setAutoBetCount, setIsAutoBetStart, setIsAutoBetOn } = autoBetStore;
      setIsAutoBetStart(false);
      setIsAutoBetOn(false);
      setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
      notificationStore.setNotification(responseCode);
    }
  }

  changeHash() {
    const { riskType, rowType, ballCount } = plinkoBetsStore;
    plinkoGameConnection.changeHash({
      plinkoRowType: rowType,
      riskType,
      ballCount,
    });
  }

  clearAutoBet() {
    clearTimeout(autoBetTimeOutId);
  }

  handleChangeHash({ hash }) {
    checkHashStore.setNextRoundHash(hash);
  }

  resetInitial() {
    plinkoBetsStore.resetStore();
  }
}

export const plinkoGameService = new PlinkoGameService();
